// 各种守卫
import util from '@/util';
import Api from '@/service';

// 处理url
// export const handleUrl = (to, from, next) => {
//   const toId = to.query.identifier;
//   const notNeedUser = to.meta.notUser;
//   const user = util.getUser();
//   let route;
//   if (toId) {
//     // 链接带id
//     toId !== user.identifier && util.setUser({ identifier: toId });
//   } else if (notNeedUser) {
//     // 链接不带id 但路由配置了该页面不需要id
//   } else if (user.identifier) {
//     // 不带id 路由要求id user有值
//     route = {
//       path: to.path,
//       query: Object.assign(
//         {
//           identifier: user.identifier,
//         },
//         to.query
//       ),
//     };
//   } else {
//     // 不带id 路由要求id user无值
//     route = {
//       name: 'error',
//       params: {
//         errMsg: $t('链接已失效！'),
//       },
//     };
//   }
//   next(route);
// };

// 进入路由前的id校验  有点繁琐可以考虑去除
export const checkIdValid = (to, from, next) => {
  const notNeedUser = to.meta.notUser;
  if (notNeedUser) {
    next();
    return;
  }
  let toRoute;
  util.async
    .getUserIdValid()
    .then(isUserIdValid => {
      !isUserIdValid &&
        (toRoute = {
          name: 'error',
          params: {
            errMsg: $t('链接已失效！'),
          },
        });
    })
    .catch(errMsg => {
      toRoute = {
        name: 'error',
        params: {
          errMsg,
        },
      };
    })
    .always(() => {
      next(toRoute);
    });
};

// 校验是否需要跳转下游
export const identityVerification = (to, from, next) => {
  const urlParams = util.getFullUrlParams();

  // 已经是下游或无身份就不跳转
  if (window.isPublic || urlParams.isEM6 || urlParams.fsAppId || !urlParams.ea) {
    return next();
  }
  Api.isOuter({ fsEa: urlParams.ea })
    .then((res = {}) => {
      const data = res.data || {};
      if (data.isOuter) {
        const searchUrlParams = Object.assign({}, urlParams, { isEM6: 1, fsAppId: data.appId });
        const searchUrlParamsStr = Object.entries(searchUrlParams).reduce(
          (result, [key, value]) => `${result}${result ? '&' : '?'}${key}=${value}`,
          ''
        );
        location.href = `${location.origin}${location.pathname}${searchUrlParamsStr}${location.hash}`;
      } else {
        return Promise.reject();
      }
    })
    .catch(errMsg => {
      next();
    });
};

// 进入路由前的id校验  有点繁琐可以考虑去除
export const handlerGlobalClass = (to, from, next) => {
  if (to.name === 'web-list') {
    document.getElementsByTagName('html')[0].classList.add('web-list');
  } else {
    document.getElementsByTagName('html')[0].classList.remove('web-list');
  }
  next();
};
